<app-navbar-style-one></app-navbar-style-one>

<section class="sign-in-area ptb-100">
    <div class="container-fluid">
        <div class="contact-wrap-form">
            <div class="row" id="signinFormContainer" *ngIf="!showOtpVerification">
                <div class="col-md-6 signForm pt-5">
                    <form [formGroup]="signupForm" id="signupForm" >
                        <div class="mb-3">
                            <label for="signup-name" class="form-label">Full Name<span class="text-danger">*</span></label>
                            <input type="text" name="name" formControlName="name" placeholder="John Doe" class="form-control" id="signup-name" required>
                            <div *ngIf="signupForm.get('name')?.hasError('required') && signupForm.get('name')?.touched" class="text-danger">
                            <small>Name is required</small>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="signup-phone" class="form-label">Phone Number<span class="text-danger">*</span></label>
                            <input name="phone" formControlName="phone" type="tel" placeholder="123-456-7890" (input)="formatPhoneNumber($event)" class="form-control" id="signup-phone" required>
                            <div *ngIf="signupForm.get('phone')?.hasError('required') && signupForm.get('phone')?.touched" class="text-danger">
                            <small>Phone number is required</small>
                            </div>
                            <div *ngIf="signupForm.get('phone')?.hasError('pattern') && signupForm.get('phone')?.touched" class="text-danger">
                            <small>Phone number must be in the format 123-456-7890</small>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="signup-email" class="form-label">Email Address<span class="text-danger">*</span></label>
                            <input type="email" class="form-control" id="signup-email"  formControlName="email" name="email"
                            placeholder="name@example.com" required>
                            <div *ngIf="signupForm.get('email')?.hasError('required') && signupForm.get('email')?.touched" class="text-danger">
                            <small>Email address is required</small>
                            </div>
                            <div *ngIf="signupForm.get('email')?.hasError('email') && signupForm.get('email')?.touched" class="text-danger">
                            <small>Email address is invalid</small>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="signup-address" class="form-label">Address<span class="text-danger">*</span></label>
                            <input type="text" id="addressInput" name="address" formControlName="address" 
                            class="form-control" placeholder="Start typing your address...">
                            <!-- <input name="address" formControlName="address" type="text" placeholder="123 Main St" 
                            class="form-control" id="signup-address" required> -->
                            <div *ngIf="signupForm.get('address')?.hasError('required') && signupForm.get('address')?.touched" class="text-danger">
                            <small>Please enter your address</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="signup-building" class="form-label">Building</label>
                                <input name="building" formControlName="building" type="text" placeholder="Ex: 10" class="form-control" id="signup-building" required>
                            </div>
                            </div>
                            <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="signup-floor" class="form-label">Floor</label>
                                <input name="floor" formControlName="floor" type="text" placeholder="Ex: 2" class="form-control" id="signup-floor" required>
                                <!-- <div *ngIf="signupForm.get('floor')?.hasError('required') && signupForm.get('floor')?.touched" class="text-danger">
                                <small>Please enter your floor</small>
                                </div> -->
                            </div>
                            </div>
                            <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="signup-flat" class="form-label">Flat</label>
                                <input name="flat" formControlName="flat" type="text" placeholder="Ex: 101" class="form-control" id="signup-flat" required>
                                <!-- <div *ngIf="signupForm.get('flat')?.hasError('required') && signupForm.get('flat')?.touched" class="text-danger">
                                <small>Please enter your flat</small>
                                </div> -->
                            </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="signup-special_mark" class="form-label">Special Mark</label>
                            <input name="special_mark" formControlName="special_mark" type="text" placeholder="Any special landmarks or directions" class="form-control" id="signup-special_mark" required>
                        </div>
                        <div class="mb-3">
                            <label for="signup-password" class="form-label">Password<span class="text-danger">*</span></label>
                            <input type="password" name="password" formControlName="password" placeholder="****************" class="form-control" id="signup-password" required>
                            <div class="text-danger" *ngIf="signupForm.get('password')?.errors">
                            <small *ngIf="signupForm.get('password')?.hasError('required')">
                                Password is required
                            </small>
                            <small *ngIf="signupForm.get('password')?.hasError('minlength')">
                                Password must be at least 8 characters
                            </small>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="signup-confirm-password" class="form-label">Confirm Password<span class="text-danger">*</span></label>
                            <input type="password" name="password_confirmation" formControlName="password_confirmation" placeholder="****************" class="form-control" id="signup-confirm-password" required>
                            <div class="text-danger" *ngIf="signupForm.get('password_confirmation')?.errors">
                            <small  *ngIf="signupForm.get('password_confirmation')?.hasError('required')">
                                Please confirm your password
                            </small>
                            </div>
                            <div *ngIf="signupForm.hasError('mismatch')" class="text-danger">
                            <small>
                                Passwords do not match
                            </small>
                            </div>
                        </div>
                    </form>                    
                </div>
                <div class="col-md-6 pt-3">
                    <div class="d-grid gap-2 text-end">
                        <a (click)="enableGuestMode()" class="link">Continue as a guest</a>
                    </div>
                    <div class="m-5 text-center">
                        <img src="assets/img/home2/login.png" alt="Sign In Image">
                        <h1 class="mt-3 signInTitle">Welcome Back, Foodie!</h1>
                        <p class="mt-5 px-5 signInParagraph">Sign in to continue your orders, track delivery, and unlock today’s specials.</p>
                    </div>
                    <div class="mt-4 text-center">
                        <button type="submit" class="btn btn-primary py-2" (click)="submitSignup()" [disabled]="isLoading">
                            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                            Sign Up
                        </button>
                    </div>
                    <div class="mt-3 text-center">
                        <p class="newAccount">Do not have account yet ? <a href="/sign-up" class="link">Sign up</a></p>
                    </div>

                    <div class="mt-5 pt-5 text-start">
                        <p class="text-start">By accessing this website, registering, or placing any order, you acknowledge and agree to be bound by the website’s Privacy Policy and Terms & Conditions.</p>
                    </div>
                </div>
            </div>

            <div class="row p-5" *ngIf="showOtpVerification">
                <div class="col-12 text-center">
                    <img src="assets/img/home2/verify.png" alt="Verify Image">
                </div>
                <div class="col-12 text-center">
                    <h1 class="mt-3 signInTitle">Verify Email</h1>
                    <p class="mt-5 px-5 signInParagraph">Please enter your email and we'll send you a 6-digit code to verify your account.</p>
                </div>
                <div class="col-12">
                    <form class="verification-otp" >
                        <div class="text-center mb-4">
                            <h5>Verify Your Email</h5>
                            <p class="text-muted">We've sent a 6-digit code to {{userEmail}}</p>
                        </div>
              
                        <div class="otp-input-group mb-4">
                            <input type="text" maxlength="1" class="form-control otp-digit" 
                                *ngFor="let box of [0,1,2,3,4,5]; let i = index"
                                [(ngModel)]="otp[i]" 
                                [ngModelOptions]="{standalone: true}"
                                (keyup)="moveToNext($event, i)">
                        </div>
              
                        <div class="d-flex justify-content-between mb-3">
                            <button type="button" class="btn btn-link" [disabled]="countdown != 0" (click)="resendOtp()">
                                Resend Code
                            </button>
                            <span class="text-muted" *ngIf="countdown > 0">
                                {{countdown}} seconds
                            </span>
                        </div>
              
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-primary py-2" 
                                [disabled]="!isOtpComplete()" 
                                (click)="verifyOtp()">
                                Verify & Continue
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>